var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-sm-12" }, [
      _c(
        "form",
        {
          attrs: {
            autocomplete: "off",
            method: "post",
            disabled: _vm.loading,
            "data-vv-scope": "form",
          },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return (() => {}).apply(null, arguments)
            },
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onBeforeSaveItem.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col-sm-auto" }, [
              _c("h1", { staticClass: "content-title" }, [
                _vm._v(_vm._s(_vm.titleItem)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-2" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialSelect",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        disabled: _vm.readonlyFormItem,
                        id: "input-active",
                        name: "active",
                        label: "name",
                        filterable: true,
                        options: _vm.lists.onoff,
                        reduce: (option) => option.code,
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("active") },
                        ],
                        error: _vm.fnFirstError("active"),
                        helpText: `${_vm.pageID}.help.active`,
                      },
                      model: {
                        value: _vm.form.active,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "active",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.active",
                      },
                    },
                    [
                      _vm._v(
                        "\n                                Ativo\n                            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-2" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialSelect",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: _vm.form.layer_id != null },
                          expression: "{required:form.layer_id!=null}",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        disabled: _vm.readonlyFormItem,
                        id: "input-private",
                        name: "private",
                        label: "name",
                        filterable: true,
                        options: _vm.lists.onoff,
                        reduce: (option) => option.code,
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("private") },
                        ],
                        error: _vm.fnFirstError("private"),
                        helpText: `${_vm.pageID}.help.private`,
                      },
                      model: {
                        value: _vm.form.private,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "private",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.private",
                      },
                    },
                    [
                      _vm._v(
                        "\n                                Privado\n                            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-2" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|integer|min_value:1",
                          expression: "'required|integer|min_value:1'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        type: "number",
                        id: "input-order",
                        name: "order",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("order") },
                        ],
                        error: _vm.fnFirstError("order"),
                        helpText: `${_vm.pageID}.help.order`,
                      },
                      model: {
                        value: _vm.form.order,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "order",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.order",
                      },
                    },
                    [
                      _vm._v(
                        "\n                                Ordem\n                            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialSelect",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: _vm.isLayer },
                          expression: "{required: isLayer}",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        disabled: _vm.readonlyFormItem,
                        id: "input-layer_id",
                        name: "layer_id",
                        label: "name",
                        filterable: true,
                        options: _vm.groups,
                        indentText: true,
                        indentationTarget: "layer_id",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("layer_id") },
                        ],
                        error: _vm.fnFirstError("layer_id"),
                        helpText: `${_vm.pageID}.help.group`,
                      },
                      model: {
                        value: _vm.form.layer_id,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "layer_id",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.layer_id",
                      },
                    },
                    [
                      _vm._v(
                        "\n                                Grupo\n                            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            !_vm.isLayer
              ? _c("div", { staticClass: "col-sm-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialSelect",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "",
                              expression: "''",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            id: "input-collapse",
                            name: "collapse",
                            label: "name",
                            filterable: true,
                            options: _vm.lists.onoff,
                            reduce: (option) => option.code,
                            inputClasses: [
                              { "is-invalid": _vm.fnHasError("collapse") },
                            ],
                            error: _vm.fnFirstError("collapse"),
                          },
                          model: {
                            value: _vm.form.collapse,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "collapse",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.collapse",
                          },
                        },
                        [
                          _vm._v(
                            "\n                                Collapsed\n                            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { class: [_vm.isLayer ? "col-sm-9" : "col-sm-8"] }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:3",
                          expression: "'required|min:3'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-name",
                        name: "name",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("name") },
                        ],
                        error: _vm.fnFirstError("name"),
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "name",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.name",
                      },
                    },
                    [
                      _vm._v(
                        "\n                                Nome\n                            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.isLayer
              ? _c("div", { staticClass: "col-sm-3" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialSelect",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: _vm.form.layer_id != null },
                              expression: "{required:form.layer_id!=null}",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            id: "input-visible",
                            name: "visible",
                            label: "name",
                            filterable: true,
                            options: _vm.lists.onoff,
                            reduce: (option) => option.code,
                            inputClasses: [
                              { "is-invalid": _vm.fnHasError("visible") },
                            ],
                            error: _vm.fnFirstError("visible"),
                            helpText: `${_vm.pageID}.help.visible`,
                          },
                          model: {
                            value: _vm.form.visible,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "visible",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.visible",
                          },
                        },
                        [
                          _vm._v(
                            "\n                                Visível\n                            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.isLayer
            ? _c("div", [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm mb-3 mb-sm-4 photos" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            { staticClass: "photo icon" },
                            [
                              _c("upload-multiple-image", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "",
                                    expression: "''",
                                  },
                                ],
                                ref: "uploadIcon",
                                attrs: {
                                  disabled: _vm.readonlyFormItem,
                                  name: "icon_layer",
                                  maxImage: 1,
                                  multiple: false,
                                  noOverlay: true,
                                  showImageLimitMessage: false,
                                },
                                model: {
                                  value: _vm.icon_layer,
                                  callback: function ($$v) {
                                    _vm.icon_layer = $$v
                                  },
                                  expression: "icon_layer",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "h6",
                                { staticClass: "font-weight-normal mt-2" },
                                [_vm._v("Copyrights")]
                              ),
                              _vm._v(" "),
                              _vm.readonlyFormItem
                                ? [
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.form.attribution),
                                      },
                                    }),
                                  ]
                                : [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "city-form-group",
                                        class: {
                                          "is-invalid":
                                            _vm.fnHasError("attribution"),
                                        },
                                      },
                                      [
                                        _c("ckeditor", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "min:3",
                                              expression: "'min:3'",
                                            },
                                          ],
                                          attrs: {
                                            name: "attribution",
                                            disabled: _vm.readonlyFormItem,
                                            editor: _vm.cKEditor.editor,
                                            config: _vm.cKEditor.editorConfig,
                                          },
                                          model: {
                                            value: _vm.form.attribution,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "attribution",
                                                $$v
                                              )
                                            },
                                            expression: "form.attribution",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.fnFirstError("attribution")
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "d-block invalid-feedback",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.fnFirstError(
                                                      "attribution"
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm mb-3 mb-sm-4 photos legend" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "MaterialSelect",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "",
                                      expression: "''",
                                    },
                                  ],
                                  staticClass: "city-form-group city-bg",
                                  attrs: {
                                    disabled: _vm.readonlyFormItem,
                                    id: "input-legend_automatic",
                                    name: "legend_automatic",
                                    label: "name",
                                    filterable: true,
                                    options: _vm.lists.onoff,
                                    reduce: (option) => option.code,
                                    inputClasses: [
                                      {
                                        "is-invalid":
                                          _vm.fnHasError("legend_automatic"),
                                      },
                                    ],
                                    error: _vm.fnFirstError("legend_automatic"),
                                    helpText: `${_vm.pageID}.help.legend_automatic`,
                                  },
                                  on: { input: _vm.onChangeLegendAutomatic },
                                  model: {
                                    value: _vm.form.legend_automatic,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "legend_automatic",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "form.legend_automatic",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                            Legenda automatica\n                                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      !_vm.form.legend_automatic
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12 mb-3" }, [
                              _c("h6", { staticClass: "font-weight-normal" }, [
                                _vm._v("Imagem"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "photo legend" },
                                [
                                  _c("upload-multiple-image", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "",
                                        expression: "''",
                                      },
                                    ],
                                    attrs: {
                                      disabled: _vm.readonlyFormItem,
                                      name: "legend_layer",
                                      imageSize: "small",
                                      direction: "horizontal",
                                      maxImage: 1,
                                      multiple: false,
                                      noOverlay: true,
                                      showImageLimitMessage: false,
                                    },
                                    model: {
                                      value: _vm.legend_layer,
                                      callback: function ($$v) {
                                        _vm.legend_layer = $$v
                                      },
                                      expression: "legend_layer",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.form.feature_info
                  ? _c("div", [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-4" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "MaterialSelect",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: _vm.form.layer_id != null,
                                      },
                                      expression:
                                        "{required:form.layer_id!=null}",
                                    },
                                  ],
                                  staticClass: "city-form-group city-bg",
                                  attrs: {
                                    disabled: _vm.readonlyFormItem,
                                    id: "input-queryable",
                                    name: "queryable",
                                    label: "name",
                                    filterable: true,
                                    options: _vm.lists.onoff,
                                    reduce: (option) => option.code,
                                    inputClasses: [
                                      {
                                        "is-invalid":
                                          _vm.fnHasError("queryable"),
                                      },
                                    ],
                                    error: _vm.fnFirstError("queryable"),
                                  },
                                  model: {
                                    value: _vm.form.feature_info.queryable,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.feature_info,
                                        "queryable",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "form.feature_info.queryable",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                        Pesquisável\n                                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-4" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "MaterialSelect",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required:
                                          _vm.form.feature_info.queryable,
                                      },
                                      expression:
                                        "{required:form.feature_info.queryable}",
                                    },
                                  ],
                                  staticClass: "city-form-group city-bg",
                                  attrs: {
                                    disabled:
                                      _vm.readonlyFormItem ||
                                      !_vm.form.feature_info.queryable,
                                    id: "input-queryable-format",
                                    name: "queryable-format",
                                    label: "name",
                                    filterable: true,
                                    options: _vm.lists.featureinfoformats,
                                    reduce: (option) => option.code,
                                    inputClasses: [
                                      {
                                        "is-invalid":
                                          _vm.fnHasError("queryable-format"),
                                      },
                                    ],
                                    error: _vm.fnFirstError("queryable-format"),
                                  },
                                  model: {
                                    value: _vm.form.feature_info.format,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.feature_info,
                                        "format",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "form.feature_info.format",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                        Formato\n                                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _c("h6", { staticClass: "mt-4" }, [_vm._v("Temas (Layers)")]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    !_vm.readonlyFormItem
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "order-2 order-sm-1 col-12 col-sm-7 col-lg-6",
                          },
                          [
                            _c("table-data", {
                              ref: "tblResources",
                              attrs: {
                                showTitleData: false,
                                tableWrapperClass: "py-2 px-1",
                                startLoad: _vm.startLoadResources,
                                route: _vm.url.getResources,
                                settings: _vm.table.settings,
                                columns: _vm.table.columns,
                                inlineFilters: _vm.table.filters,
                                autoUpdateFilter: _vm.table.autoUpdateFilter,
                                externalFilters: _vm.tblFilters,
                                autoUpdateExternalFilter:
                                  _vm.table.autoUpdateExternalFilter,
                                addParamsToUrl: _vm.table.addParamsToUrl,
                                loadingMsg: _vm.table.loadingMsg,
                                notFoundMsg: _vm.table.notFoundMsg,
                                orderByTemplate: _vm.table.orderByTemplate,
                              },
                              on: { "error-load": _vm.showError },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "filters",
                                    fn: function ({ tableFilters, search }) {
                                      return [
                                        _c(
                                          "form",
                                          {
                                            attrs: { autocomplete: "false" },
                                            on: {
                                              submit: function ($event) {
                                                $event.preventDefault()
                                                return search.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                              keyup: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                return search.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "row header" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-12" },
                                                  [
                                                    _c("header-list", {
                                                      attrs: {
                                                        title: null,
                                                        placeholderSearch:
                                                          _vm.searchPlaceholder,
                                                        headerClass: "mb-3",
                                                      },
                                                      model: {
                                                        value: tableFilters.q,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            tableFilters,
                                                            "q",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "tableFilters.q",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "body",
                                    fn: function ({ row, index, remove }) {
                                      return [
                                        _c(
                                          "td",
                                          { class: _vm.table.columns[0].class },
                                          [
                                            _c("ResourceItemList", {
                                              attrs: {
                                                value: row,
                                                enableCrossResource:
                                                  _vm.enableCrossresources,
                                                readonlyForm:
                                                  _vm.readonlyFormItem,
                                              },
                                              on: {
                                                addResource: function ($event) {
                                                  return _vm.addResource(
                                                    row,
                                                    index,
                                                    remove
                                                  )
                                                },
                                                addCrossResource: function (
                                                  $event
                                                ) {
                                                  return _vm.addCrossResource(
                                                    row,
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1293587968
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "order-1 order-sm-2 col-12 col-sm-5 col-lg-6",
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "d-flex justify-content-between justify-content-md-start align-items-center",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "text-muted pr-md-4" },
                                    [_vm._v(_vm._s(_vm.help.resources_title))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-secondary badge-pill",
                                    },
                                    [_vm._v(_vm._s(_vm.form.resources.length))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-group city-form-group" },
                                [
                                  !_vm.readonlyFormItem
                                    ? _c("help-span", {
                                        attrs: {
                                          helpText: _vm.help.resources_layers,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.fnHasError("resources")
                                    ? _c(
                                        "small",
                                        {
                                          staticClass:
                                            "invalid-feedback d-block",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.fnFirstError("resources")
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "draggable",
                                _vm._b(
                                  {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: { required: true, length: 1 },
                                        expression:
                                          "{required: true, length: 1}",
                                      },
                                    ],
                                    attrs: {
                                      tag: "div",
                                      draggable: ".list-group-item",
                                      name: "resources",
                                    },
                                    on: {
                                      start: _vm.onDragStart,
                                      end: _vm.onDragEnd,
                                    },
                                    model: {
                                      value: _vm.form.resources,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "resources", $$v)
                                      },
                                      expression: "form.resources",
                                    },
                                  },
                                  "draggable",
                                  _vm.dragOptions,
                                  false
                                ),
                                [
                                  _c(
                                    "transition-group",
                                    {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                        },
                                      ],
                                      staticClass: "p-0",
                                      attrs: {
                                        tag: "ul",
                                        type: "transition",
                                        name: !_vm.drag ? "flip-list" : null,
                                      },
                                    },
                                    _vm._l(
                                      _vm.form.resources,
                                      function (element, idx) {
                                        return _c(
                                          "li",
                                          {
                                            key: element.id,
                                            staticClass:
                                              "list-group-item p-0 border-0 cursor-default",
                                          },
                                          [
                                            _c("ResourceItemSelected", {
                                              attrs: {
                                                value: element,
                                                readonlyForm:
                                                  _vm.readonlyFormItem,
                                                pivotKey: _vm.pivotResources,
                                              },
                                              on: {
                                                removeResource: function (
                                                  $event
                                                ) {
                                                  return _vm.removeResource(idx)
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ])
            : _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-3" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialColorPicker",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: !_vm.form.layer_id },
                              expression: "{required:!form.layer_id}",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            id: "input-icon_bg_color",
                            name: "icon_bg_color",
                            inputClasses: [
                              { "is-invalid": _vm.fnHasError("icon_bg_color") },
                            ],
                            error: _vm.fnFirstError("icon_bg_color"),
                            helpText: `${_vm.pageID}.help.icon_bg_color`,
                          },
                          model: {
                            value: _vm.form.icon_bg_color,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "icon_bg_color",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.icon_bg_color",
                          },
                        },
                        [
                          _vm._v(
                            "\n                                Côr\n                            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-9" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialInput",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: !_vm.form.layer_id },
                              expression: "{required:!form.layer_id}",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            type: "text",
                            id: "input-icon",
                            name: "icon",
                            inputClasses: [
                              { "is-invalid": _vm.fnHasError("icon") },
                            ],
                            error: _vm.fnFirstError("icon"),
                            helpText: `${_vm.pageID}.help.icon`,
                          },
                          model: {
                            value: _vm.form.icon,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "icon",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.icon",
                          },
                        },
                        [
                          _vm._v(
                            "\n                                Icon\n                            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
          _vm._v(" "),
          _c("buttons-footer", {
            attrs: {
              enableButtons: !_vm.readonlyFormItem,
              cancelTitle: _vm.cancelTitle,
              submitTitle: _vm.submitTitle,
              isDisabled: _vm.isDisabled,
            },
            on: {
              save: _vm.onBeforeSaveItem,
              cancel: function ($event) {
                return _vm.handleBack(`${_vm.moduleCode}.${_vm.pageID}`, true)
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("h6", { staticClass: "font-weight-normal" }, [_vm._v("Icon")]),
        _vm._v(" "),
        _c("hr", { staticClass: "mt-2" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("h6", { staticClass: "font-weight-normal" }, [_vm._v("Legenda")]),
        _vm._v(" "),
        _c("hr", { staticClass: "mt-2" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("h6", [_vm._v("Feature Info")]),
        _vm._v(" "),
        _c("hr", { staticClass: "my-3" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }